/* eslint-disable no-console */
import { GQLPlugin } from '../GQLTypes';
import { crossEnv } from '@sbvr/lbe-environment';

const abortControllers: Map<string, AbortController> = new Map();

export const CancelPlugin: GQLPlugin = ({ beforeRequest, onClientError, GQLClient }) => {
  beforeRequest.push((request, options) => {
    const { cancelKey } = options;
    if (cancelKey) {
      const abortController = abortControllers.get(cancelKey);
      abortController && abortController.abort();
      const newAbortController = new AbortController();
      abortControllers.set(cancelKey, newAbortController);
      const newRequest = new Request(request, { ...options, headers: request.headers, signal: newAbortController.signal });
      return newRequest;
    }
  });

  GQLClient.cancelLast = function (cancelKey) {
    const abortController = abortControllers.get(cancelKey);
    abortController && abortController.abort();
  };

  onClientError.push((error, options) => {
    const { cancelKey, throwAbortError = false } = options;
    if (error.name === 'AbortError' && !throwAbortError) {
      crossEnv.NODE_ENV !== 'production' &&
        console.warn(`AbortError: a query with cancelKey - ${cancelKey} - was cancelled`);
    } else {
      throw error;
    }
  });
};
